/* eslint-disable sort-keys */
/* eslint sort-keys: ["error", "asc", {natural: true, caseSensitive: false}] */
const errorMessage = {
  notFoundProjectInFp: '找不到指定的專案（FP）',
  validation: '輸入值無效：{0}',
};

export const messagesInZhHant = {
  // 共通仕様: その他例外
  '/error/global/0000': '出現未知錯誤',
  '/error/global/0001': '您的存取令牌已過期',
  '/error/global/0002': '發生未知的伺服器錯誤',
  '/error/global/0003': '找不到該專案。請聯繫管理員。如果有必要，請聯繫Taisei IT服務台（s-net@pub.taisei.co.jp）。',
  '/error/global/0004': '暫無專案邀請訊息。請聯繫管理員。如果有必要，請聯繫Taisei IT服務台（s-net@pub.taisei.co.jp）。',
  '/error/global/0005': '該專案已刪除。請聯繫管理員。如果有必要，請聯繫Taisei IT服務台（s-net@pub.taisei.co.jp）。',
  '/error/global/0006': '沒有可以顯示的專案。請聯繫管理員。如果有必要，請聯繫Taisei IT服務台（s-net@pub.taisei.co.jp）。',
  '/error/global/0007': '該專案（服務）已刪除。請聯繫管理員。如果有必要，請聯繫Taisei IT服務台（s-net@pub.taisei.co.jp）。',
  '/error/global/0008': '該專案（服務）已關閉。請聯繫管理員。如果有必要，請聯繫Taisei IT服務台（s-net@pub.taisei.co.jp）。',
  // [図面API](002001) Myショートカット検索
  '/error/S-CAPI-DDMS-002001/0001': errorMessage.validation,
  '/error/S-CAPI-DDMS-002001/1001': errorMessage.notFoundProjectInFp,
  // (001001) プロジェクト情報一覧
  '/error/S-CAPI-FP-001001/0001': errorMessage.validation,
  '/error/S-CAPI-FP-001001/0002': errorMessage.notFoundProjectInFp,
  // (001002) デフォルトプロジェクト取得
  '/error/S-CAPI-FP-001002/0001': errorMessage.validation,
  '/error/S-CAPI-FP-001002/0002': '您可切換至想檢視的專案。',
  '/error/S-CAPI-FP-001002/0003': '暫無專案邀請訊息。',
  '/error/S-CAPI-FP-001002/0004': '沒有可以顯示的專案。',
  '/error/S-CAPI-FP-001002/0005': '該專案服務正在準備中。',
  // (001003) デフォルトプロジェクト更新
  '/error/S-CAPI-FP-001003/0001': errorMessage.validation,
  '/error/S-CAPI-FP-001003/0002': errorMessage.notFoundProjectInFp,
  // (001004) プロジェクト詳細取得
  '/error/S-CAPI-FP-001004/0001': errorMessage.validation,
  // (001005) プロジェクト招待者取得
  '/error/S-CAPI-FP-001005/0001': errorMessage.validation,
  '/error/S-CAPI-FP-001005/0002': errorMessage.notFoundProjectInFp,
  // (001006) プロジェクト情報取得
  '/error/S-CAPI-FP-001006/0001': errorMessage.validation,
  '/error/S-CAPI-FP-001006/0002': errorMessage.notFoundProjectInFp,
  // (001008) 役割追加更新
  '/error/S-CAPI-FP-001008/0001': errorMessage.validation,
  '/error/S-CAPI-FP-001008/0002': errorMessage.notFoundProjectInFp,
  // (001009) 未使用役割一覧取得
  '/error/S-CAPI-FP-001009/0001': errorMessage.validation,
  '/error/S-CAPI-FP-001009/0002': errorMessage.notFoundProjectInFp,
  // (002002) レイアウト更新
  '/error/S-CAPI-FP-002002/0001': errorMessage.validation,
  '/error/S-CAPI-FP-002002/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-002002/0004': '找不到指定的配置',
  // (002004) レイアウト追加
  '/error/S-CAPI-FP-002004/0001': errorMessage.validation,
  // (002005) レイアウト一覧取得
  '/error/S-CAPI-FP-002005/0001': errorMessage.validation,
  '/error/S-CAPI-FP-002005/0002': '該專案無可顯示的配置。請聯繫Taisei IT服務台（s-net@pub.taisei.co.jp）。',
  // (002006) デフォルトレイアウト取得
  '/error/S-CAPI-FP-002006/0001': errorMessage.validation,
  '/error/S-CAPI-FP-002006/0002': errorMessage.notFoundProjectInFp,
  // (002007) デフォルトレイアウト更新
  '/error/S-CAPI-FP-002007/0001': errorMessage.validation,
  '/error/S-CAPI-FP-002007/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-002007/0003': '找不到指定的配置',
  // (002008) 管理者用レイアウト一覧取得
  '/error/S-CAPI-FP-002008/0001': errorMessage.validation,
  '/error/S-CAPI-FP-002008/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-002008/0003': '您沒有編輯管理員配置的權限',
  // (002009) レイアウト名変更
  '/error/S-CAPI-FP-002009/0001': errorMessage.validation,
  '/error/S-CAPI-FP-002009/0002': errorMessage.notFoundProjectInFp,
  // (002010) レイアウト削除
  '/error/S-CAPI-FP-002010/0001': errorMessage.validation,
  '/error/S-CAPI-FP-002010/0002': errorMessage.notFoundProjectInFp,
  // (004001) メインメニュー詳細取得
  '/error/S-CAPI-FP-004001/0001': errorMessage.validation,
  '/error/S-CAPI-FP-004001/0002': errorMessage.notFoundProjectInFp,
  // (004003) 管理者用メインメニュー詳細取得
  '/error/S-CAPI-FP-004003/0001': errorMessage.validation,
  '/error/S-CAPI-FP-004003/0002': '您沒有編輯管理員主選單的權限',
  // (005001) ダウンロード履歴検索結果取得
  '/error/S-CAPI-FP-005001/0001': errorMessage.validation,
  '/error/S-CAPI-FP-005001/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-005001/0003': '找不到數據源（API）來取得下載歷史記錄',
  // (005002) 新着通知検索結果取得
  '/error/S-CAPI-FP-005002/0001': errorMessage.validation,
  '/error/S-CAPI-FP-005002/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-005002/0003': '找不到數據源（API）來取得新訊息',
  // (005003) 保存済み検索条件詳細取得
  '/error/S-CAPI-FP-005003/0001': errorMessage.validation,
  '/error/S-CAPI-FP-005003/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-005003/0003': '找不到指定的搜索條件',
  // (005004) 新着通知既読更新
  '/error/S-CAPI-FP-005004/0001': errorMessage.validation,
  '/error/S-CAPI-FP-005004/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-005004/0003': '訊息無法載入',
  // (006001) 保存済み検索条件一覧取得
  '/error/S-CAPI-FP-006001/0001': errorMessage.validation,
  '/error/S-CAPI-FP-006001/0002': errorMessage.notFoundProjectInFp,
  // (006002) 保存済み検索条件取得
  '/error/S-CAPI-FP-006002/0001': errorMessage.validation,
  '/error/S-CAPI-FP-006002/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-006002/0003': '找不到指定的搜索條件',
  // (006004) 保存済み検索条件追加更新
  '/error/S-CAPI-FP-006004/0001': errorMessage.validation,
  '/error/S-CAPI-FP-006004/0002': errorMessage.notFoundProjectInFp,
  // (006005) 保存済み検索条件削除
  '/error/S-CAPI-FP-006005/0001': errorMessage.validation,
  '/error/S-CAPI-FP-006005/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-006005/0003': '找不到指定的搜索條件',
  '/error/S-CAPI-FP-006005/0004': '指定的搜索條件無法刪除，因為它已經在小工具中使用',
  // (007001) 拡張属性定義一覧取得
  '/error/S-CAPI-FP-007001/0001': errorMessage.validation,
  // (007002) ユーザー拡張属性定義削除
  '/error/S-CAPI-FP-007002/0001': errorMessage.validation,
  // (007003) ユーザー拡張属性定義登録
  '/error/S-CAPI-FP-007003/0001': errorMessage.validation,
  '/error/S-CAPI-FP-007003/0002': '無法登錄擴充屬性定義',
  // (007004) ユーザー拡張属性定義更新
  '/error/S-CAPI-FP-007004/0001': errorMessage.validation,
  '/error/S-CAPI-FP-007004/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-007004/0003': '無法更新擴充屬性定義',
  // (007005) 拡張属性定義関連内容タグ一覧取得
  '/error/S-CAPI-FP-007005/0001': errorMessage.validation,
  // (007006) 拡張属性区分値一括登録
  '/error/S-CAPI-FP-007006/0001': errorMessage.validation,
  '/error/S-CAPI-FP-007006/0002': '未找到擴充屬性定義',
  '/error/S-CAPI-FP-007006/0003': '無法登錄擴充屬性定義的類別值',
  // (007007) 拡張属性区分値一括更新
  '/error/S-CAPI-FP-007007/0001': errorMessage.validation,
  '/error/S-CAPI-FP-007007/0002': '未找到擴充屬性定義',
  '/error/S-CAPI-FP-007007/0003': '找不到要更新的分類值',
  '/error/S-CAPI-FP-007007/0004': '無法更新擴充屬性定義的分類值',
  // (007008) 拡張属性定義関連内容タグ一括更新
  '/error/S-CAPI-FP-007008/0001': errorMessage.validation,
  '/error/S-CAPI-FP-007008/0002': '無法更新擴充屬性定義相關的內容標籤',
  // (007009) 拡張属性区分値削除
  '/error/S-CAPI-FP-007009/0001': errorMessage.validation,
  '/error/S-CAPI-FP-007009/0002': '未找到擴充屬性定義',
  '/error/S-CAPI-FP-007009/0003': '找不到要更新的分類值',
  '/error/S-CAPI-FP-007009/0004': '無法刪除擴充屬性定義的類別值',
  // (008001) 内容タグツリー取得
  '/error/S-CAPI-FP-008001/0001': errorMessage.validation,
  '/error/S-CAPI-FP-008002/0001': '您沒有存取指定專案的權限',
  // (009001) ラック検索
  '/error/S-CAPI-FP-009001/0001': errorMessage.validation,
  '/error/S-CAPI-FP-009001/0002': '擴充屬性不正確',
  // (010001) 内容タグViewパターン一覧取得
  '/error/S-CAPI-FP-010001/0001': errorMessage.validation,
  '/error/S-CAPI-FP-010001/0002': errorMessage.notFoundProjectInFp,
  // (011001) データラック一覧取得
  '/error/S-CAPI-DDMS-051001/0001': errorMessage.validation,
  '/error/S-CAPI-DDMS-051001/0002': errorMessage.validation,
  // (011001) ファイルダウンロード(購読制御入り)
  '/error/S-CAPI-DDMS-010003/0001': errorMessage.validation,
  '/error/S-CAPI-DDMS-010003/0002': errorMessage.validation,
  'dataRackSearch.error': '{0}的訊息取得失敗。',
  '/error/S-CAPI-DDMS-010003/0006': '找不到新通知',
  'addSearchCriteriaButton.label': '增加搜尋條件',
  'ContentTagRoleAccessPermissionModelAccessTypeEnum.READ': '參照',
  'ContentTagRoleAccessPermissionModelAccessTypeEnum.READ_WRITE': '更新',
  'ContentTagRoleAccessPermissionModelAccessTypeEnum.undefined': '不明確的',
  'DataBoxModelApprovalTypeEnum.APPROVED': '已核可',
  'DataBoxModelApprovalTypeEnum.APPROVING': '核可中',
  'DataBoxModelApprovalTypeEnum.DENIAL': '否認',
  'DataBoxModelApprovalTypeEnum.PARTIAL_APPROVAL': '部分核可',
  'DataBoxModelApprovalTypeEnum.UNAPPROVED': '未核可',
  'DataBoxModelApprovalTypeEnum.undefined': '',
  'dialog.apply': '適用',
  'dialog.cancel': '取消',
  'dialog.close': '關閉',
  'dialog.delete.message': '請注意，若刪除則無法復原。',
  'dialog.delete.title': '確定要刪除?',
  'dialog.editAttributeValueName.label.name': '顯示名稱',
  'dialog.editGadgetImage.label.color': '背景顏色',
  'dialog.editGadgetImage.label.image': '圖像URL',
  'dialog.editGadgetImage.message': '指定所選小工具的背景圖像的URL。',
  'dialog.editGadgetImage.title': '應用背景圖像',
  'dialog.editGadgetName.title': '編輯小工具的顯示名稱',
  'dialog.layoutAdd.description': '請輸入配置名稱。',
  'dialog.layoutAdd.title': '新增配置',
  'dialog.layoutEdit.message.confirm': '輸入內容將遺失，您確定嗎?',
  'dialog.layoutEdit.message.leave': '嘗試移動頁面。',
  'dialog.layoutEdit.title': '確認是否離線',
  'dialog.layoutEditChange.message.change': '嘗試切換配置。',
  'dialog.layoutEditChange.message.confirm': '輸入內容將遺失，您確定嗎?',
  'dialog.layoutEditChange.title': '確認切換配置',
  'dialog.layoutNameEdit.description': '請輸入配置名稱。',
  'dialog.layoutNameEdit.title': '更改配置名稱',
  'dialog.leaveLayoutEdit.message': '您確定要保存當前正在編輯的內容並跳至檔案搜尋頁面嗎？',
  'dialog.leaveLayoutEdit.title': '跳至檔案搜尋頁面。',
  'dialog.ok': 'OK',
  'dialog.roleAdd.message': '輸入職務代碼和職務名稱。',
  'dialog.roleAdd.note': '如果此職務代碼已經存在，它將被覆蓋。',
  'dialog.roleAdd.title': '增加職務',
  'dialog.roleChanger.title': '變更配置職務',
  'dialog.roleChanger.unusedRole': '未使用的職務',
  'downloadHistory.contentTagName': '文件夾名稱',
  'downloadHistory.dataRackName': '文件名',
  'downloadHistory.downloadAt': '下載時間',
  'extensiveAttribute.availableFlag': '可用的',
  'extensiveAttribute.commonManagementFlag': '類型',
  'extensiveAttribute.contentTags': '擴充屬性文件夾',
  'extensiveAttribute.extensiveAttributeDefinition': '擴充屬性定義',
  'extensiveAttribute.extensiveAttributeDefinitionName': '擴充屬性名稱',
  'extensiveAttribute.extensiveAttributeValue': '分類',
  'extensiveAttribute.valueEditAllowFlag': '可編輯分類',
  'extensiveAttribute.valueType': '擴充屬性類型',
  'ExtensiveAttributeModel.availableFlag.label': '可用的',
  'ExtensiveAttributeModel.commonManagementFlag.label': '類型',
  'ExtensiveAttributeModel.commonManagementFlag.label.COMMON': '標準',
  'ExtensiveAttributeModel.commonManagementFlag.label.undefined': '未知類型',
  'ExtensiveAttributeModel.commonManagementFlag.label.USER': '使用者',
  'ExtensiveAttributeModel.descriptionText.label': '描述',
  'ExtensiveAttributeModel.extensiveAttributeDefinitionName.label': '屬性名',
  'ExtensiveAttributeModel.valueType.label': '數值型',
  'ExtensiveAttributeModel.valueType.label.BOOL': '真偽值/布林值',
  'ExtensiveAttributeModel.valueType.label.DATE': '日期',
  'ExtensiveAttributeModel.valueType.label.DATETIME': '日期時間',
  'ExtensiveAttributeModel.valueType.label.MULTI_SELECT': '分類(複選)',
  'ExtensiveAttributeModel.valueType.label.NUMBER': '數值',
  'ExtensiveAttributeModel.valueType.label.SINGLE_SELECT': '分類(單選)',
  'ExtensiveAttributeModel.valueType.label.TEXT': '文字',
  'ExtensiveAttributeModel.valueType.label.WHOLE_NUMBER': '含0的正整數',
  'ExtensiveAttributeModel.valueType.label.undefined': '未知類型',
  'ExtensiveAttributeValueModel.common_management_flag.COMMON': '標準',
  'ExtensiveAttributeValueModel.common_management_flag.undefined': '未知類型',
  'ExtensiveAttributeValueModel.common_management_flag.USER': '使用者',
  'field.displayName.en': '顯示名稱（En）',
  'field.displayName.ja': '顯示名稱',
  'field.roleCode': '職務代碼',
  'FpCustomColumnMenu.label.save': '儲存',
  'FpDownloadHistoryGrid.message': '顯示最近90天的歷史紀錄',
  'FpExtensiveAttribute.commonManagementFlag.common': '標準',
  'FpExtensiveAttribute.commonManagementFlag.user': '使用者',
  'FpExtensiveAttribute.flag.true': '是的',
  'FpExtensiveAttribute.header.edit': '編輯',
  'FpExtensiveAttribute.header.new': '新增',
  'FpExtensiveAttribute.valueType.bool': '真偽值/布林值',
  'FpExtensiveAttribute.valueType.date': '日期',
  'FpExtensiveAttribute.valueType.datetime': '日期時間',
  'FpExtensiveAttribute.valueType.multiSelect': '複選型分類',
  'FpExtensiveAttribute.valueType.number': '數字',
  'FpExtensiveAttribute.valueType.singleSelect': '單選型分類',
  'FpExtensiveAttribute.valueType.text': '文字',
  'FpExtensiveAttribute.valueType.wholeNumber': '含0的正整數',
  'FpExtensiveAttributeGrid.filter.hint': '以擴充屬性名篩選',
  'FpExtensiveAttributesAdd.title': '增加擴充屬性定義',
  'FpExtensiveAttributesContentTagManagement.title': '編輯擴充屬性文件夾',
  'FpExtensiveAttributesEdit.error': '無法編輯的擴充屬性',
  'FpExtensiveAttributesEdit.title': '編輯擴充屬性定義',
  'FpExtensiveAttributesFolderSelect.confirm.body': '確定儲存此次編輯嗎?',
  'FpExtensiveAttributesFolderSelect.filter.label': '以文件夾名稱篩選',
  'FpExtensiveAttributesValuesEdit.error': '無法編輯的分類',
  'FpExtensiveAttributesValuesEdit.success': '變更內容已保存',
  'FpExtensiveAttributesValuesEdit.title': '編輯擴充屬性分類',
  'FpExtensiveAttributesValuesEdit.warning': '無變更',
  'FpExtensiveAttributeValueDetail.delete.description': '請注意，如果刪除文件，則無法還原。',
  'FpExtensiveAttributeValueDetail.delete.title': '刪除選定的類別值',
  'FpFileSearch.criteria-save-as': '將此搜尋條件命名並保存',
  'FpFileSearch.label.clear': '清除',
  'FpFileSearch.label.save': '節省',
  'FpFileSearch.notification.project-not-found': '另一項專案已指定搜尋條件。',
  'FpFileSearch.notification.save-criteria.error': '儲存搜尋條件時發生未知錯誤。',
  'FpFileSearch.notification.save-criteria.success': '搜尋條件已保存',
  'FpFileSearch.notification.search.error': '文件搜索時發生錯誤。',
  'FpFileSearchCommonCriteria.label.created-at': '創建於',
  'FpFileSearchCommonCriteria.label.creator': '建立者',
  'FpFileSearchCommonCriteria.label.file-name': '文件名',
  'FpFileSearchCriteria.label.back': '返回',
  'FpFileSearchCriteria.label.clear': '清除',
  'FpFileSearchCriteria.label.save': '儲存',
  'FpFileSearchCriteria.label.search': '搜尋',
  'FpFileSearchCriteria.label.search-criteria': '高級搜索',
  'FpFileSearchCriteria.search-criteria-advanced': '高級搜索（如果指定了多個條件，則應使用"或"條件。）',
  'FpFileSearchCriteria.criteria-required': '請輸入一個或多個搜尋條件進行搜尋',
  'FpFileSearchResult.header.details.title': '文件詳細資訊',
  'FpFileSearchWrapper.criteria.not-found': '找不到指定的搜尋條件',
  'FpFolderSearch.filter.label': '以文件夾名稱篩選',
  'FpFolderSearch.notification.warn.view-pattern-not-found': '無法取得VIEW pattern',
  'FpGadgetButtonGroup.title': '無法編輯從模板複製的小工具',
  'FpLayoutCopy.destination-list.chip.create': '新的',
  'FpLayoutCopy.destination-list.chip.template': '模板',
  'FpLayoutCopy.destination-list.selected-project.count': '選擇的專案',
  'FpLayoutCopy.destination-type.copied': '顯示一般專案',
  'FpLayoutCopy.destination-type.template': '顯示專案模板',
  'FpLayoutCopy.notification.success': '配置已複製完成',
  'FpLayoutCopy.section-title.destinations': '選擇複製目的地',
  'FpLayoutCopyPreview.preview-type.copied': '複製結果',
  'FpLayoutCopyPreview.preview-type.destination': '複製目的地',
  'FpLayoutCopyPreview.preview-type.source': '複製源',
  'FpLayoutEdit.role_view.title': '本社支店職務一覽',
  'FpMainMenuEditFileSearch.description': '編輯{0}使用中的主選單。',
  'FpMainMenuEditFileSearch.dialog.title': '文件',
  'FpMainMenuEditFileSearch.label.add': '增加',
  'FpMainMenuEditRoleList.title': '可顯示的職務一覽',
  'FpMainMenuEditSearchCriteria.title': '文件搜尋',
  'FpMainMenuEditSplitter.custom.label': '自定義項目',
  'FpMainMenuEditSplitter.etc.file': '增加文件',
  'FpMainMenuEditSplitter.etc.folder': '增加文件夾',
  'FpMainMenuEditSplitter.etc.label': '其他的',
  'FpMainMenuEditSplitter.normal.label': '基本項目',
  'FpMainMenuEditSplitter.normal.subTitle': '副標題',
  'FpMainMenuEditSplitter.normal.text': '文字',
  'FpMainMenuEditSplitter.normal.url': 'URL',
  'FpMainMenuItemAddAction.button': '增加',
  'FpProjectList.footer.exists': '已找到{0}件專案',
  'FpProjectList.footer.notFound': '沒有專案',
  'FpProjectSplitter.filter.hint': '篩選專案',
  'FpProjectTree.show-all': '顯示全部',
  'FpRole.delete.description': '請注意，如果刪除文件，則無法還原。',
  'FpRole.delete.title': '確定要刪除嗎？',
  'FpRoleSelectGroup.button.all': '全部',
  'FpSearchCriteriaCard.delete-confirm.body': '若刪除則無法復原。',
  'FpSearchCriteriaCard.delete-confirm.title': '刪除已選擇的搜尋條件',
  'FpSearchCriteriaCard.disabled.title': '無法編輯從模板複製的搜尋條件。',
  'FpSearchCriteriaCard.layout-list': '目前使用以下配置。',
  'FpSearchCriteriaCard.not-in-use': '未使用。',
  'FpSearchCriteriaCard.unmodifiable-alert-dialog.body': '無法刪除此配置，因目前有參照搜尋條件的配置，請編輯小工具並取消參照。',
  'FpSearchCriteriaCard.unmodifiable-alert-dialog.title': '無法刪除已選之搜尋條件',
  'FpSearchCriteriaManagement.delete.error': '刪除過程中發生了錯誤。請再試一次。',
  'FpSearchCriteriaManagement.delete.success': '搜尋條件已刪除',
  'FpSearchCriteriaManagement.filter.hint': '以搜尋條件名稱篩選',
  'FpSearchCriteriaManagement.no-criteria': '沒有搜尋條件',
  'FpSearchCriteriaManagement.title': '管理搜尋條件',
  'FpSearchCriteriaManagement.title.description': '編輯此專案管理的搜尋條件。',
  'FpSearchCriteriaSave.dialog.title': '命名並儲存',
  'FpPortal.DownloadError': '{0}下載失敗。',
  'FpPortal.DownloadStatusError': '{0}無法下載。',
  'gadgetContents.empty.label': '沒有資料',
  'gadgetContents.warning.label': '編輯時無法顯示',
  'gadgetSelect.download.description': '在專案中下載的文件',
  'gadgetSelect.download.label': '下載歷史記錄',
  'gadgetSelect.mainMenu.description': '文件夾和工作所需的文件的捷徑',
  'gadgetSelect.mainMenu.label': '主選單',
  'gadgetSelect.myShortcut.description': '個人新增的連結',
  'gadgetSelect.myShortcut.label': '我的捷徑',
  'gadgetSelect.newArrival.description': '專案中文件的最新訊息',
  'gadgetSelect.newArrival.label': '最新訊息',
  'gadgetSelect.searchCriteria.description': '已儲存搜尋條件的搜尋結果',
  'gadgetSelectGroup.label': '可使用的小工具',
  'grid.noRecords': '沒有資料',
  'header.title': '文件入口網',
  'header.userInfo': '您已登錄為{0}。',
  'label.access-level': '存取權限',
  'label.add': '增加',
  'label.approval_type': '核可之類別',
  'label.back': '返回',
  'label.cancel': '取消',
  'label.changing': '更改',
  'label.create_company_name': '製作公司',
  'label.created-at': '製作時間',
  'label.creater': '由...製作',
  'label.data_item_count': '資料項目數',
  'label.delete': '刪除',
  'label.details': '詳細',
  'label.edit': '編輯',
  'label.file-name': '文件名',
  'label.folder': '文件夾',
  'label.folder-name': '文件夾名稱',
  'label.folder-search': '搜尋文件夾',
  'label.gadget-name': '小工具名稱',
  'label.gadget-type': '小工具類型',
  'label.gadget-type.GT1': '主選單',
  'label.gadget-type.GT2': '原始搜尋條件',
  'label.gadget-type.GT3': '下載歷史記錄',
  'label.gadget-type.GT4': '最新訊息',
  'label.gadget-type.GT5': '我的捷徑',
  'label.headquarters_role.change': '變更本社支店職務',
  'label.headquarters_role.show': '顯示本社支店職務',
  'label.preview': '預覽',
  'label.project_status.CLOSED': '完成',
  'label.project_status.DELETE': '刪除',
  'label.project_status.FROZEN': '凍結',
  'label.project_status.OPEN': '使用中',
  'label.reload': '重新加載',
  'label.role': '職務名稱',
  'label.role-code': '職務代碼',
  'label.role-list': '職務一覽',
  'label.role-name': '職務名稱',
  'label.save': '儲存',
  'label.updated-at': '更新時間',
  'label.updater': '更新者',
  'label.mark_as_read': '已讀',
  'label.download': '下載',
  'label.view': '觀看',
  'layoutEdit.cancel.label': '取消',
  'layoutEdit.changeRole.label': '變更專案之職務',
  'layoutEdit.preview.back': '編輯',
  'layoutEdit.preview.label': '預覽',
  'layoutEdit.save.label': '儲存',
  'layoutEdit.warning.label': '編輯模板配置中',
  'layoutPreview.note': '預覽顯示中',
  'layoutRole.addLayout': '增加配置',
  'layoutRole.addRole': '增加新的職務',
  'layoutRole.copy': '複製到另一個專案',
  'layoutRole.deleteLayout': '刪除配置',
  'layoutRole.editLayout': '編輯配置',
  'layoutRole.editName': '變更配置名稱',
  'layoutRole.unusedRole': '未使用的職務',
  'link.attr': '管理擴充屬性定義',
  'link.layout': '配置管理',
  'link.projectDetail': '專案詳細',
  'link.projectSwitch': '切換專案',
  'link.search': '管理搜尋條件',
  'link.top': '入口網',
  logout: '登出',
  'mainMenuEditGridColumnProps.displayNameEn': '顯示名稱（En）',
  'mainMenuEditGridColumnProps.displayNameJa': '顯示名稱',
  'mainMenuEditGridColumnProps.type': '類型',
  'mainMenuGrid.button.delete': '刪除',
  'mainMenuGrid.button.edit': '編輯',
  'mainMenuGrid.button.preview': '預覽',
  'mainMenuItemTypeCode.type.MT1': '副標題',
  'mainMenuItemTypeCode.type.MT2': '文字',
  'mainMenuItemTypeCode.type.MT3': 'URL',
  'mainMenuItemTypeCode.type.MT4': '已儲存的搜尋條件',
  'mainMenuItemTypeCode.type.MT5': '文件夾',
  'mainMenuItemTypeCode.type.MT6': '文件',
  'myshortcut.error.model': '非預期的回傳值',
  'newArrivalNotification.content_tag_name': '文件夾名稱',
  'newArrivalNotification.data_rack_name': '文件名',
  'newArrivalNotification.notification_content': '通知內容',
  'newArrivalNotification.read': '已讀',
  'newArrivalNotification.source_user_name_without_middle_name': '更新者',
  'newArrivalNotification.source_xgrab_user_company_name': '更新公司名稱',
  'newArrivalNotification.unread': '未讀',
  'newArrivalNotification.updated_at': '更新時間',
  'newArrivalNotification.loading': '載入中...',
  'notification.extensiveAttributeDefinitionCreate.success': '編輯內容已保存',
  'notification.extensiveAttributeDefinitionUpdate.success': '編輯內容已保存',
  'notification.layoutCreate.success': '配置已登錄',
  'notification.layoutDelete.success': '配置已刪除',
  'notification.layoutNameUpdate.success': '配置名已變更',
  'notification.layoutUpdate.error': '配置更新失敗：{0}',
  'notification.layoutUpdate.success': '配置已更新',
  'notification.putExtensiveAttributesAppliedContentTags.error': '無法將擴充屬性應用於內容標籤',
  'notification.putExtensiveAttributesAppliedContentTags.success': '已將擴充屬性應用於內容標籤',
  'notification.roleCreate.success': '職務已註冊',
  'notification.roleDelete.success': '職務已刪除',
  'notification.download.waiting': '待機中',
  'page.description.extensiveAttribute': '編輯與擴充屬性或文件夾的連結',
  'page.description.layout-copy': '將配置複製到選定的目標。',
  'page.description.layoutRole': '管理專案的配置與職務。',
  'page.description.mainMenuEditList': '編輯{0}使用中的主選單',
  'page.description.projectSelect': '切換至已選的專案',
  'page.title.extensiveAttribute': '管理擴充屬性',
  'page.title.layout-copy': '複製配置',
  'page.title.layout-copy-preview': '預覽複製的配置',
  'page.title.layoutRole': '配置管理',
  'page.title.mainMenuEditList': '編輯{0}',
  'page.title.projectSelect': '切換專案',
  'project.list.title': '專案一覽',
  'projectDetail.description': '{0}的詳細',
  'projectDetail.label.address': '地址',
  'projectDetail.label.area': '區域',
  'projectDetail.label.branchObjectName': '本店或支店名稱',
  'projectDetail.label.businessTypeName': '工種名稱',
  'projectDetail.label.constructionPlaceAddress': '建築地址',
  'projectDetail.label.endedOn': '截止日',
  'projectDetail.label.faxNumber': '傳真號碼',
  'projectDetail.label.ownerCompanyName': '所有者公司名稱',
  'projectDetail.label.ProjectGroupCompletedAt': '案件群組完成日',
  'projectDetail.label.projectGroupName': '案件群組名稱',
  'projectDetail.label.projectGroupStatus': '案件群組狀態',
  'projectDetail.label.projectName': '案件群組名',
  'projectDetail.label.projectStatus': '專案狀態',
  'projectDetail.label.projectType': '專案類型名稱',
  'projectDetail.label.responsiblePersonName': '負責人姓名',
  'projectDetail.label.startedOn': '起始日',
  'projectDetail.label.telNumber': '電話號碼',
  'projectDetail.title': '專案詳細',
  'projectDetail.title.info': '專案訊息',
  'projectDetail.title.invitee': '專案成員',
  'searchResult.contentTagName': '文件夾名稱',
  'searchResult.dataItemCount': '資料項目個數',
  'searchResult.rackName': '文件名',
  'searchResult.sequenceNumber': '最新版本',
  'searchResult.updateCompanyName': '更新公司名稱',
  'searchResult.updatedAt': '更新時間',
  'searchResult.updateUserName': '更新者',
  'service.file': '文件',
  'service.picture': '照片',
  'service.title': '文件入口網',
  'service.pjInvite': '專案邀請',
  'service.groupManager': '小組經理',
  'service.spiderPlus': 'Spiderplus連結',
  'service.exchangeManager': 'Exchange 經理',
  'update.confirm.title': '更新確認',
  'validation.formatRegExp.message': '請以[{0}]的形式輸入',
  'validation.max.message': '請輸入{0}個以內之文字',
  'validation.min.message': '請輸入{0}個以上之文字',
  'validation.range.message': '必須在{0}和{1}之間。',
  'validation.required.message': '此為必填項目',
  'validation.uri.message': '請輸入http:、https:或ftpURL:作為起始值',
  'validation.integer.message': '必須是整數。',
  'notification.projectRead.warning': '沒有邀請專案。',
  'fileServiceLeftPaincontrolType.message': '打開此連結時打開文件夾列表（左窗格）',
};
